import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class EnrollmentService {

  constructor(private http: CustomHttpService) { }

    deleteEnrollment(data:any): Observable<any> {
    return this.http.post(environment.deleteEnrollment,data);
  }

  bulkUpdateEnrollment(data: any): Observable<any> {
    return this.http.post(environment.bulkUpdateEnrollment, data);
  }
  
}
